import { useMutation } from '@apollo/client';
import type { VariablesOf } from '@graphql-typed-document-node/core';
import { SessionActions } from '../../account/sessionSlice';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';

const USER_SETTINGS_MUTATION = gql(/** @complexity 10 */ `
  mutation updateUserSettings(
    $allowAccountAccess: Boolean
    $notifications: UserSettingsNotificationsInput
    $uiTheme: UiThemeSetting
    $aiAutofix: Boolean
    $aiPredict: Boolean
    $preferDesktop: Boolean
    $aiAsk: Boolean
  ) {
    settings: updateUserSettings(
      allowAccountAccess: $allowAccountAccess
      notifications: $notifications
      uiTheme: $uiTheme
      aiAutofix: $aiAutofix
      aiPredict: $aiPredict
      preferDesktop: $preferDesktop
      aiAsk: $aiAsk
    ) {
      ...setUserSetting_userSetting
    }
  }
`);

export default function useUpdateUserSettings() {
  const dispatch = useAppDispatch();
  const [mutate] = useMutation(USER_SETTINGS_MUTATION);

  return (params: VariablesOf<typeof USER_SETTINGS_MUTATION>) =>
    mutate({ variables: params }).then(({ data } = {}) => {
      if (data?.settings) {
        dispatch(SessionActions.setUserSetting(data.settings));
      }
    });
}
